<script>

	import { onMount } from 'svelte';
	import { createEventDispatcher } from 'svelte';

	import { fade, slide } from 'svelte/transition';
  	
	const dispatch = createEventDispatcher()

	onMount(() => {})

	let visible = false
    let application = {}

	export const start = (app) => {
        application = app
		visible = true
	}

	export const stop = (action = 'close') => {
		dispatch('close', {
			action : action
		});
		visible = false
	}

	const handleClose = () => {
		stop()
	}


</script>

{#if visible}
    <div class="fullscreen" on:click={handleClose} transition:fade="{{ y: 200, duration: 200 }}"></div>
    <div class="container main-modal" transition:slide="{{ x: -200, duration: 200 }}">
        <div class="row justify-content-center">
            <div class="col-md-6 main-list" >
                <h5>{application.name}</h5>
                <p>{application.description}</p>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-md-6 main-list-sub" >
                <div class="list-group">
                    <a href="{application.main_url}" on:click={handleClose} target="__blank" class="list-group-item list-group-item-action">Ouvrir {application.name}</a>
                    {#if application.help_url}
                    <a href="{application.help_url}" on:click={handleClose} target="__blank" class="list-group-item list-group-item-action">Accéder à l'aide</a>
                    {/if}
                </div>
            </div>
        </div>
    </div>
{/if}

<style>

    .fullscreen {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom : 0;
        background-color: rgba(0, 0, 0, 0.33);
    }

	.main-modal {
		position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
	}

    .main-list {
        background: white;
        border-radius: 10px 10px 0px 0px;
        padding: 15px;
    }

    .main-list-sub {
        background: white;
        padding: 15px;
    }

</style>
